import api, { checkTokenErrorResponse } from '..';

export async function postCallList(turmaId, atividade, hora, treino = null) {
    return api.post(`turmas/${turmaId}/listas/`, {
        atividade,
        hora,
        treino
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getCallLists(turmaId) {
    return api.get(`turmas/${turmaId}/listas/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postGroupCheckin(turmaId, callListId, alunos) {
    return api.post(`turmas/${turmaId}/listas/${callListId}/check_in/`, alunos)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postGroupCheckout(turmaId, callListId, alunos) {
    return api.post(`turmas/${turmaId}/listas/${callListId}/check_out/`, alunos)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

const callListServices = {
    postCallList,
    getCallLists,
    postGroupCheckin,
    postGroupCheckout,
}
export default callListServices;